import { OrderInfoRow } from '../utils/models';


export function showMessage( 
  message: string,
  header: string,
  backdrop: boolean = true,
  orderInfo?: OrderInfoRow[]
) {
  const messageEl: HTMLTambrMessageElement = document.createElement('tambr-message');
  messageEl.header = header;
  messageEl.message = message;
  messageEl.backdrop = backdrop;
  if ( orderInfo ) messageEl.orderInfo = orderInfo;
  messageEl.addEventListener( 'tambrMessageClose', () => messageEl.remove() );
  document.body.appendChild( messageEl );
}